import './index.scss';
import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import ProductInformationCodesViewCodeGroups from "./code-groups";
import {Typography} from "@mui/material";
import ProductInformationUPCsViewUPCs from "./upcs";
import {ProductCodeSplitterSelect, useProductCodeSplitter} from "../../../../../../components/app-specific/product-code-splitter";

const ProductInformationCodesView = ({productId, loading, setIsCacheNeeded, setPartUPC}) => {
    const {splitter, loading: loadingSplitter, changeSplitter} = useProductCodeSplitter();

    return (
        <>
            <Grid container spacing={2} className={'product-information-codes-view w-100'}>
                {
                    !loading &&
                    <Grid xs={12}>
                        <div className={'part-info-paper p-3 d-flex align-items-center justify-content-between'} style={{gap: 12}}>
                            <div className={'d-flex flex-column'}>
                                <Typography variant={'body1'} fontWeight={600}>
                                    Code Splitter
                                </Typography>
                                <Typography variant={'body2'}>
                                    This value determines how we split your entered code values while creating new codes for your products.
                                </Typography>
                            </div>
                            <ProductCodeSplitterSelect
                                value={splitter}
                                onChange={changeSplitter}
                                loading={loadingSplitter}
                            />
                        </div>
                    </Grid>
                }
                <ProductInformationUPCsViewUPCs
                    productId={productId}
                    loading={loading}
                    splitter={splitter}
                    setPartUPC={setPartUPC}
                />
                <ProductInformationCodesViewCodeGroups
                    productId={productId}
                    setIsCacheNeeded={setIsCacheNeeded}
                    loading={loading}
                    splitter={splitter}
                />
            </Grid>
        </>
    );
}
export default ProductInformationCodesView;
